import { module } from 'modujs';
import Env from '../base/env';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
  }

  toggle(e) {
    // console.log(e);
    if (e.mode == 'enter' && e.direction == 'down') {
      Env.$html.classList.add('purchase-bar-hidden');
    }

    if (e.mode == 'leave' && e.direction == 'up') {
      Env.$html.classList.remove('purchase-bar-hidden');
    }
  }
}
